import { render, staticRenderFns } from "./ForgotPasswordResult.vue?vue&type=template&id=18b0c1ec&"
import script from "./ForgotPasswordResult.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports